<template>
  <el-dialog :visible="show" @close="$emit('close')" >
    <el-tabs v-model="curId" type="card">
      <el-tab-pane :label="item.name" :name="item.id" v-for="item in message" :key="item.id">
        <div class="flex-center flex-col">
          <img :src="item.collecimage" style="width:20vw;">
          <span class="pt-5">{{ item.collecinfo
          }}</span>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import { watchEffect, ref } from "@vue/composition-api"
export default {
  props: {
    show: Boolean,
    sid: [Number, String]
  },
  setup(props, ctx) {
    const message = ref()
    const curId = ref()
    watchEffect(async () => {
      if (props.sid && props.show) {
        let res = await ctx.root.$callapi('sup/getCollectionInfo', { sid: props.sid })
        if (res.code == 0 && res.data) {
          let items = res.data.items
          items?.map(item => {
            item.id = item.id.toString()
          })
          curId.value = items[0]?.id
          message.value = items

        }
      }
    })
    return { message, curId }
  }
}

</script>